// Get job search SEO data ******************************
// pathname: v2/jobs/seo-data
// ******************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface UseSwrJobSearchSeoProps {
  urlParams?: string;
  locale?: string;
  shouldFetch?: boolean;
  serverSideData?: ApiSchema<'SeoData'> | null;
}

/**
 * @description SWR fetch job search SEO data.
 * - **queryParams**: JobSearchQueryParams. The query params to use for the request.
 * - **locale**: string, optional. What locale to use for the request. Default 'ro'.
 * - **shouldFetch**: boolean, optional. Whether to fetch the data or not. Default true.
 */
export const useSwrJobSearchSeo = (props: UseSwrJobSearchSeoProps) => {
  const {
    urlParams, serverSideData, locale = 'ro', shouldFetch = true,
  } = props;

  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'SeoData'>>({
    url: '/v2/jobs/seo-data',
    urlParams,
    locale,
    shouldFetch,
    serverSideData,
    apiOptions: {
      // 10 minute
      dedupingInterval: 10 * 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
